import PropTypes from 'prop-types';
import classNames from 'classnames';
import {
  TimeLabel,
} from 'vibeguide';
import SnapshotDay from './SnapshotDay';
import './SnapshotGrid.scss';

function SnapshotGrid({
  className = '',
  mediaFormat = 'audio',
  playlists = [],
  mixes = [],
  messageBlocks = [],
  interruptions = [],
  loops = [],
  disabled = false,
  onClickDay = () => {},
}) {
  const slots = [
    '00:00',
    '04:00',
    '08:00',
    '12:00',
    '16:00',
    '20:00',
    '00:00',
  ];

  return (
    <div className={classNames('SnapshotGrid', className)}>
      <div className="snapshot-grid">
        {slots.map((slot, index) => {
          const position = index + 1;

          return (
            <div
              key={`slot-${slot}-${index}`}
              className="time-grid"
              style={{
                top: 24 * position,
              }}
            />
          );
        })}
      </div>

      <div className="snapshot-columns">
        <div className="snapshot-col">
          {slots.map((slot, index) => {
            return (
              <TimeLabel
                key={`slot-time-${slot}-${index}`}
                className="time"
                time={slot}
                showTooltip
              />
            );
          })}
        </div>

        <div className="snapshot-col">
          S

          <div className="snapshot-data">
            <SnapshotDay
              day="Sun"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>

        <div className="snapshot-col">
          M

          <div className="snapshot-data">
            <SnapshotDay
              day="Mon"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>

        <div className="snapshot-col">
          T

          <div className="snapshot-data">
            <SnapshotDay
              day="Tue"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>

        <div className="snapshot-col">
          W

          <div className="snapshot-data">
            <SnapshotDay
              day="Wed"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>

        <div className="snapshot-col">
          T

          <div className="snapshot-data">
            <SnapshotDay
              day="Thu"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>

        <div className="snapshot-col">
          F

          <div className="snapshot-data">
            <SnapshotDay
              day="Fri"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>

        <div className="snapshot-col">
          S

          <div className="snapshot-data">
            <SnapshotDay
              day="Sat"
              mediaFormat={mediaFormat}
              playlists={playlists}
              stations={mixes}
              messageBlocks={messageBlocks}
              interruptions={interruptions}
              loops={loops}
              disabled={disabled}
              onClickDay={onClickDay}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

SnapshotGrid.propTypes = {
  className: PropTypes.string,
  mediaFormat: PropTypes.oneOf([
    'audio',
    'visual',
  ]),
  playlists: PropTypes.arrayOf(PropTypes.object),
  mixes: PropTypes.arrayOf(PropTypes.object),
  messageBlocks: PropTypes.arrayOf(PropTypes.object),
  interruptions: PropTypes.arrayOf(PropTypes.object),
  loops: PropTypes.arrayOf(PropTypes.object),
  disabled: PropTypes.bool,
  onClickDay: PropTypes.func,
};

export default SnapshotGrid;
